/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Feat_CityInputs */

const cs_pm_feat_city = /** @type {(inputs: Pm_Feat_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obec`)
};

const en_pm_feat_city = /** @type {(inputs: Pm_Feat_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Pm_Feat_CityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_feat_city = /** @type {((inputs?: Pm_Feat_CityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Feat_CityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_feat_city(inputs)
	return cs_pm_feat_city(inputs)
});